import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CareMobilityFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M4.71253 8.02974L4.71253 8.97737L6.60775 8.97737L6.60777 9.92498L8.09685 9.92498C9.00741 10.0655 10.1662 9.07937 10.4317 8.17894H16.7432C17.2432 8.17894 17.6485 8.58429 17.6485 9.08431V10.5537L18.9038 11.0801H18.9419V9.08431C18.9419 7.86997 17.9575 6.88555 16.7432 6.88555H10.4598C10.1953 5.82836 9.25258 5.06195 8.16453 5.11922L6.67541 5.11922L6.67543 6.06683L4.78019 6.06686L4.78019 7.01444L6.67543 7.01447L6.67541 7.96208L4.71253 8.02974ZM5.00484 17.5696H5.53967C6.02927 19.0839 8.54349 19.5445 9.40416 17.5696H14.5161C15.1841 19.295 17.8135 19.4486 18.4784 17.2387L20.1915 16.4652V12.9412L16.1125 11.2304C15.7538 11.0854 15.374 11.002 14.9885 10.9837L12.111 10.9831C11.3711 10.9831 10.646 11.1899 10.0128 11.5803L8.03121 12.6949L7.84242 12.7299C5.2927 13.202 4.04664 13.4327 3.80888 15.4427L3.80859 15.4509V16.3503C3.80859 16.9727 4.30194 17.5869 5.00484 17.5696Z"
      />
    </SvgIcon>
  );
});
